import StyledComponent from 'styled-components';

const Container = StyledComponent.div`

			min-height: 80%;
			overflow-y: scroll;
			padding: 15px 15px;
			@media(min-width: 600px)
			{
				min-width: 500px;
			}

			.main-btn-section, .bottom-btn-section
			{
				margin-bottom: 25px;
				margin-top: 8px;
				justify-content: space-between;
		    display: flex;
			}
			.bottom-btn-section
			{
				margin-bottom: 0px;
				margin-top: 50px;
				justify-content: space-between;
		    display: flex;
			}
      .select-container: {
        min-width: 100%;
      }
			.schema-name
			{
				width: 100%;
				margin-top: 10px;
			}
			.schema-list
			{
				margin-top: 25px;
			}
			.table-properties-btn
			{
				margin-top: 15px;
			}
			.admin-table-properties
			{
				margin-top: 15px;
				width: 100%;
			}
			.table-properties
			{
				margin-top: 15px;
				width: 100%;
				font-size: 10px;

				textarea
				{
					white-space: pre-line;
				}
			}
			.schema-btns
			{
				margin-bottom: 10px;
			}
			.schema-form
			{
				margin-top: 15px;
			}
			.model-list
			{
				margin-top: 15px;

				h1
				{
					text-align: left;
				}
				h2
				{
					text-align: left;
					color: black;
				}
			}
			.MuiChip-outlinedPrimary
			{
				width: 100%;
				margin-top: 10px;
			}

			.job-description
			{
				color: black;
				text-align: left;
				margin: auto;
			}

			.checkbox-label
			{
				color: #3f51b5;
			}

			.select-control
			{
				width: 100%

				@media(min-width: 600px)
				{
					width: 25%;
				}
			}

			nav
			{
				display: flex !important;
				padding: 16px !important;
			}
		`;

  export {
    Container
  };